import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { JobPointeTransferService } from '../../job-pointe-transfer/job-pointe-transfer.service';
import { JobBoardService } from '../service/job-board.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { PermissionsService } from 'src/app/service/auth/permissions.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { Subscription } from 'rxjs';
import type { ElementRef } from '@angular/core';

@Component({
  selector: 'app-job-card',
  templateUrl: './job-card.component.html',
  styleUrls: ['./job-card.component.scss'],
})
export class JobCardComponent implements OnInit, OnChanges {
  @Input() id!: string;
  @Input() cardData: any;
  @Input() staticData: any;
  @Input() cardDepartment: string;
  @Input() selectedCard: any;
  @Input() tagAssignments: Array<any> = [];
  @ViewChild(`facilityCollapseDiv`) facilityCollapseDiv: ElementRef<HTMLDivElement>
  @ViewChild(`jobCollapseDiv`) jobCollapseDiv: ElementRef<HTMLDivElement>

  selectedEmployeeCards: Array<any>;
  separateJobCardData: Array<any> = [];
  facilityCardData: Array<any> = [];
  foremanList: Array<any> = [];
  cardTypeStates: any = {};
  cardType: string;
  jobBoardLocked: boolean = false;
  jobBoardLockedSubscription: Subscription;

  constructor(
    private momentService: MomentService,
    public jobBoardService: JobBoardService,
    private jobPointeTransferService: JobPointeTransferService,
    private localStorageService: LocalstorageService,
    private jobPointeService: JobPointeService,
    private toastService: ToastService,
    private permissionsService: PermissionsService,
  ) { }

  async ngOnInit() {
    this.refreshCardData();
    this.cardDepartment = this.cardDepartment.replace(/[^\w]/g, ''); //remove special characters and spaces from department name
    this.foremanList = await this.staticData.foremanList;
    this.cardTypeStates = this.getLocalCardState() || this.cardTypeStates;
    this.initCardCollapseState();

    this.jobBoardLockedSubscription = this.jobBoardService.jobBoardLockedSource.subscribe(res => {
      this.jobBoardLocked = res;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cardData && !changes.cardData.firstChange) {
      this.refreshCardData();
    }
  }

  refreshCardData() {
    this.facilityCardData = this.cardData?.potentialJobDetail?.jobs.filter(j => !j.isSeparateOnJobBoard);
    this.separateJobCardData = this.cardData?.potentialJobDetail?.jobs.filter(j => j.isSeparateOnJobBoard);
    this.cardType = this.separateJobCardData.length > 0 ? 'job' : 'facility'; // Set Card type for when there are separate jobs and facility jobs
  }

  ngOnDestroy() {
    if (this.jobBoardLockedSubscription) this.jobBoardLockedSubscription.unsubscribe();
  }

  initCardTypeState(attribute = undefined, value = undefined) {
    const type = this.cardType;
    const id = this.cardData.id;
    const dept = this.cardDepartment;

    if (!this.cardTypeStates?.[type]) this.cardTypeStates[type] = {};
    if (!this.cardTypeStates?.[type]?.[dept]) this.cardTypeStates[type][dept] = {};
    if (!this.cardTypeStates?.[type]?.[dept]?.[id]) this.cardTypeStates[type][dept][id] = {};
    if (attribute && !this.cardTypeStates[type][dept][id]?.[attribute]) {
      this.cardTypeStates[type][dept][id][attribute] = value;
    }

  }

  formatDate(date: string) {
    return date ? this.momentService.formateDate(date) : '';
  }

  stateChange(attribute: string, newState: boolean) {

    this.cardTypeStates = this.getLocalCardState() || this.cardTypeStates;

    if (!this.getState(attribute)) {
      this.initCardTypeState(attribute, newState);
    } else {
      this.cardTypeStates[this.cardType][this.cardDepartment][this.cardData.id][attribute] = newState;
    }
    this.setLocalCardState();
  }

  getCardTags(cardData) {
    if (cardData?.jobNumber) {
      return this.tagAssignments.filter(t => t.jobId == cardData.id);
    }
    return this.tagAssignments.filter(t => t.facilityId == cardData.id);
  }

  assignTag(event, targetCard) {
    const { dragData: tag } = event;
    const payload = {
      tagId: tag.id,
      ...(targetCard?.jobNumber && { jobId: targetCard.id }),
      ...(targetCard?.facilityName && { facilityId: targetCard.id }),
      ...(targetCard?.employeeAlias && { userId: targetCard.id }),
    };

    this.jobPointeService.create['jobBoardTagAssignment'](payload).subscribe(res => {
      if (res.success) {
        this.tagAssignments.push(res.tagAssignment);
      }
    });
  }

  removeCardTag(tagAssignment, targetCard) {
    this.jobPointeService.delete['jobBoardTagAssignment']({
      id: tagAssignment.id,
    }).subscribe(
      res => {
        if (res.success) {
          this.tagAssignments = this.tagAssignments.filter(ta => ta.id != tagAssignment.id);
        }
      },
      err => {
        if (err.status == 404) {
          this.tagAssignments = this.tagAssignments.filter(ta => ta.id != tagAssignment.id);
        }
      },
    );
  }

  getCardEmployees(scheduleEmployees) {
    //sort by employeeTitle and employee name

    return scheduleEmployees
      .map(s => s.employee)
      .sort((a, b) => {
        const empName1 = a?.employeeAlias.trim() ? a.employeeAlias.trim() : `${a.firstName} ${a.lastName}`;
        const empName2 = b?.employeeAlias.trim() ? b.employeeAlias.trim() : `${b.firstName} ${b.lastName}`;
        if (empName1 < empName2) {
          return -1;
        }
        if (empName1 > empName2) {
          return 1;
        }
        return 0;
      })
      .sort((a, b) => {
        return (
          (a.employeeTitle?.rank ? a.employeeTitle.rank : Infinity) -
          (b.employeeTitle?.rank ? b.employeeTitle.rank : Infinity)
        );
      });
  }

  async setJobNotes(event, cardData) {
    if (event.target.value == cardData.jobBoardNotes) return;
    const payload = [
      {
        name: cardData.name,
        status: cardData.status,
        job_number: cardData.jobNumber,
        job_board_notes: event.target.value,
      },
    ];
    const { batchResponse: result } = await this.jobPointeService.update['jobs'](payload).toPromise();
    if (result?.success.length > 0) {
      cardData.jobBoardNotes = event.target.value;
      this.toastService.showToast('Job Notes updated successfully', 'success');
    } else {
      this.toastService.showToast('Error updating Job Notes', 'error');
    }
  }

  async setJobAlias(event, cardData) {
    const payload = [
      {
        name: cardData.name,
        status: cardData.status,
        job_number: cardData.jobNumber,
        job_board_alias: event.target.value,
      },
    ];
    await this.jobPointeService.update['jobs'](payload).toPromise();
    cardData.jobBoardAlias = event.target.value;
  }

  async setJobMainForeman(foreman, cardData) {
    const payload = [
      {
        name: cardData.name,
        status: cardData.status,
        job_number: cardData.jobNumber,
        job_board_main_foreman: foreman.toString(),
      },
    ];
    await this.jobPointeService.update['jobs'](payload).toPromise();
    cardData.jobBoardMainForeman = foreman;
  }

  async setFacilityNotes(event, cardData) {
    if (event.target.value == cardData.jobBoardNotes) return;

    const payload = {
      id: cardData.id,
      jobBoardNotes: event.target.value,
    };

    const result = await this.jobPointeService.update['facilities'](payload).toPromise();

    if (result.success) {
      cardData.jobBoardNotes = event.target.value;
      this.toastService.showToast('Facility Notes updated successfully', 'success');
    } else {
      this.toastService.showToast('Error updating Facility Notes', 'error');
    }
  }

  async setFacilityAlias(event, cardData) {
    const payload = {
      id: cardData.id,
      jobBoardAlias: event.target.value,
    };
    await this.jobPointeService.update['facilities'](payload).toPromise();
    cardData.jobBoardAlias = event.target.value;
  }

  async setFacilityMainForeman(foreman, cardData) {
    const payload = {
      id: cardData.id,
      jobBoardMainForeman: foreman.toString(),
    };
    await this.jobPointeService.update['facilities'](payload).toPromise();
    cardData.jobBoardMainForeman = foreman;
  }

  getState(attribute: string) {
    return this.cardTypeStates?.[this.cardType]?.[this.cardDepartment]?.[this.cardData.id]?.[attribute];
  }

  initCardCollapseState() {
    const collapseDiv = this.cardType == 'job' ? this.jobCollapseDiv : this.facilityCollapseDiv;
    if (this.getState('isCollapsed')) {
      collapseDiv.nativeElement.classList.add('show');
    } else {
      collapseDiv.nativeElement.classList.remove('show');
    }
  }

  formatToCurrency(amt: number) {
    let isNegative = false;
    if (amt < 0) {
      isNegative = true;
      amt *= -1;
    }

    const currency = Math.floor(amt).toLocaleString('en-US', {
      minimumFractionDigits: 2,
    });
    return isNegative ? `($${currency})` : `$${currency}`;
  }

  getFacilitySiteLocals() {
    const { jobs } = this.cardData.potentialJobDetail;
    const siteLocals = jobs
      .filter(j => !j.isSeparateOnJobBoard)
      .map(j => j?.jobDetail?.unionLocal?.unionLocalId)
      .filter(s => s);
    return Array.from(new Set(siteLocals)).join(', ');
  }

  getFacilityAddress() {
    return `${this.cardData?.streetAddress.trim()},\
      ${this.cardData?.city.trim()},\
      ${this.cardData?.facilityState?.abbreviation},\
      ${this.cardData?.zipcode.trim()}`.trim();
  }

  getProjectManagersList(cardType) {
    const { jobs } = this.cardData.potentialJobDetail;
    const projectManagers = jobs
      .filter(j => (cardType == 'job' ? j.isSeparateOnJobBoard : !j.isSeparateOnJobBoard))
      .map(j => {
        return j.jobDetail?.potentialJob?.projectManager?.employeeAlias;
      });
    return Array.from(new Set(projectManagers)).join(', ');
  }

  getLastAddedJob(jobs) {
    const lastAddedDate = Math.max(
      ...jobs.map(j => {
        if (j.lastOnJobBoardDate) {
          return new Date(`${j.lastOnJobBoardDate} EDT`).getTime();
        }
        return false;
      }),
    );
    return lastAddedDate ? `${this.momentService.formateDate(new Date(lastAddedDate).toString())}` : '';
  }

  setLocalCardState() {
    this.localStorageService.setItem(
      `cardTypeStates`,
      JSON.stringify({ ...this.getLocalCardState(), ...this.cardTypeStates }),
    );
  }

  getLocalCardState() {
    return JSON.parse(this.localStorageService.getItem(`cardTypeStates`));
  }

  openAddEmployeeModal(cardType, cardData) {
    this.jobPointeTransferService.addEmployeeModalIsOpenSource.next({
      isOpen: true,
      cardData,
      cardType,
    });
  }

  openJobSideNav(cardData) {
    cardData.cardType = this.cardType;
    this.jobBoardService.jobSideBarOpen.next(cardData);
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      job_board_attributes: 'job_board_attributes',
      job_pointe_employees: 'job_pointe_employees',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }

  isListDisabled(): boolean {
    return !this.isAllowed('job_board_attributes', 'edit');
  }

  getCardName(isSingleJob: boolean, jobCardData): string {
    if (isSingleJob) {
      return jobCardData.name;
    }

    const { facilityName, owner } = this.cardData;

    return `${owner.owner_name}_${facilityName}`;
  }

  emitExport(exportType: string, jobCardData?: Record<string, unknown>) {
    const cardJobIds = this.cardData?.potentialJobDetail?.jobs?.map(el => el.id) ?? [];

    const isSingleJob = this.cardType === 'job';

    const jobIds = isSingleJob ? [jobCardData.id] : cardJobIds;

    const isHRList = exportType === 'siteHrList';

    const params = {
      'scope[job]': [jobIds],
    };

    const cardName = this.getCardName(isSingleJob, jobCardData);

    if (isHRList && isSingleJob) {
      params['scope[standaloneJobCardScheduleEmployees]'] = true;
    }

    if (isHRList) {
      params['scope[employeeTagsAttributes]'] = true;
    }

    this.jobPointeService.export['jobBoardCard']({
      exportType,
      ...params,
    }, isSingleJob).subscribe(
      res => {
        const exportName = isHRList ? 'Site HR' : 'Site Crew List';
        const fileName = `${cardName}_${exportName}`;

        this.downloadFile(res.body, fileName);
      },
      err => {
        console.error(err);
      },
    );
  }

  downloadFile(blob: Blob, fileType: string) {
    const a = document.createElement('a');
    const currentDate = this.momentService.getCurrentDate('MMDDYYYY');
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = `${currentDate}_${fileType}_export.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  trackByJobId(index: number, item: any): number {
    return item.id;
  }

  trackByEmployeeId(index: number, item: any): number {
    return item.id;
  }

  trackByTagId(index: number, item: any): number {
    return item.id;
  }
}
